import { css } from "@emotion/react";
import styled from "@emotion/styled";

import Block, { IBlockProps } from "components/layout/Block";
import { styleCss } from "components/layout/utils";

// TODO: group all colors in IViewContainerTheme under one key (and have one Interface for Theme colors)
export interface ITextProps extends IBlockProps {
  color?: string;
  inline?: boolean;
  fontSize?: string;
  fontFamily?: string;
  fontWeight?: string;
  lineHeight?: string;
  verticalAlign?: string;
  wordWrap?: string;
  textDecoration?: string;
  textAlign?: "left" | "right" | "justify" | "center" | "start" | "end";
  textTransform?: "uppercase" | "lowercase" | "capitalize" | "initial" | "inherit" | "none";
  textOverflow?: "ellipsis" | "clip" | string;
  whiteSpace?: "normal" | "pre" | "nowrap" | "pre-wrap" | "-moz-pre-wrap" | "pre-line" | "inherit";
  overflowWrap?: "normal" | "break-word" | "anywhere";
}

const Text = styled(Block.withComponent("span"))<ITextProps>`
  ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) =>
      props.color &&
      css`
        color: ${props.theme[props.color]};
      `
  };
  ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) =>
      props.inline &&
      css`
        display: inline;
      `
  };
  ${styleCss("color")};
  ${styleCss("fontFamily")};
  ${styleCss("fontSize")};
  ${styleCss("fontWeight")};
  ${styleCss("lineHeight")};
  ${styleCss("textAlign")};
  ${styleCss("textTransform")};
  ${styleCss("textOverflow")};
  ${styleCss("whiteSpace")};
  ${styleCss("verticalAlign")};
  ${styleCss("textDecoration")};
  ${styleCss("wordWrap")};
  ${styleCss("overflowWrap")};
`;

export default Text;
